module.exports = __webpack_public_path__ + "static/media/38pic.e7bc136d.jpg";